import CircularProgress from "@mui/material/CircularProgress";
export default () => <CircularProgress disableShrink />;
